module.exports = __webpack_public_path__ + "d85af1a35f9175dc5f23d3c3cd18d047.png";